<app-graph [data]="data()" [options]="options" type="choropleth"></app-graph>
